export default __webpack_public_path__ + "static/media/icons-system-expand.b454238a.svg";